import React from "react"
import Proptypes from "prop-types"
import { Row, Col } from "reactstrap"

import PlatformImg from "../../../../images/covid19/Platform for Conference.png"

const covid19Solutions = props => {
  return (
    <div className="covid-solutions" id={props.blue ? "blue" : ""}>
      <div className="title large-font">{props.title}</div>
      {!props.reverse ? (
        <Row>
          <Col sm="6" xs="12">
            <img
              src={props.image}
              alt="Looking for an expert Jitsi Meet Developer ? Contact Meetrix.IO now !"
            />
          </Col>
          <Col sm="6" xs="12" className="text">
            <div className="description medium-font">{props.description}</div>
            {props.data.map(data => (
              <div className="solutions-list medium-font">
                {data.description ? (
                  <div className="link-description">{data.description}</div>
                ) : (
                  ""
                )}
                {data.link ? <a href={data.link}>{data.linkName}</a> : ""}
              </div>
            ))}
          </Col>
        </Row>
      ) : (
        <Row>
          <Col sm="6" xs="12" className="text">
            <div className="description medium-font">{props.description}</div>
            {props.data.map(data => (
              <div className="solutions-list medium-font">
                {data.description ? (
                  <div className="link-description">{data.description}</div>
                ) : (
                  ""
                )}
                {data.link ? <a href={data.link}>{data.linkName}</a> : ""}
              </div>
            ))}
          </Col>
          <Col sm="6" xs="12">
            <img
              src={props.image}
              alt="Multi Region, Auto Scaled Jitsi Meet deployment. Contact Meetrix.IO now !"
            />
          </Col>
        </Row>
      )}
    </div>
  )
}

covid19Solutions.prototype = {
  title: Proptypes.any,
  description: Proptypes.any,
  image: Proptypes.any,
  data: Proptypes.any,
  reverse: Proptypes.any,
  blue: Proptypes.any,
  linkName: Proptypes.any,
  link: Proptypes.any,
}

export default covid19Solutions
